<template>
  <div>
    <div v-if="selected">
      <template v-if="userschoolstypeaccess.length > 1">
        <button @click="selected = null"
          class="btn btn-success position-absolute rounded rounded-pill top-btn d-flex align-items-center px-3">
          <svg class="mr-2" height="20" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
            fill="currentColor">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z"
              clip-rule="evenodd"> </path>
          </svg>
          Zurück
        </button>
      </template>
      <div id="card" class="card">
        <div class="card-body">
          <div class="container">
            <div class="row my-2 align-items-center">
              <div class="col-8 text-center text-white fw-bold mb-2 mb-md-0 offset-2" style="font-size: calc(1.5rem + 1vw);">
                WILLKOMMEN!
              </div>
              <div class="col-3 col-md-2 mx-auto d-flex justify-content-center">
                  <div v-if="isAdmin" class="cursor-pointer text-center" @click="typeSelect('junior/admin')">
                    <img class="img-fluid" src="https://cdn.minticity.com/assets/images/choice/admin-icon.png">
                  </div>
                  <div class="cursor-pointer text-center" @click="typeSelect('logout')">
                    <img class="img-fluid" src="https://cdn.minticity.com/assets/images/choice/logout-icon.png">
                  </div>
              </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 d-flex justify-content-center">
              <div v-if="selected.access.kids" class="cursor-pointer text-center cardItem" @click="typeSelect('kids')">
                <img src="https://cdn.minticity.com/assets/images/choice/kids.png" class="img-fluid">
              </div>
              <div v-if="selected.access.junior" class="cursor-pointer text-center cardItem"
                @click="typeSelect('junior')">
                <img src="https://cdn.minticity.com/assets/images/choice/junior.png" class="img-fluid">
              </div>
              <div v-if="selected.access.teenage" class="cursor-pointer text-center cardItem"
                @click="typeSelect('teenage')">
                <img src="https://cdn.minticity.com/assets/images/choice/teenage.png" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 text-center">
              <a href="https://www.minticity.com/">
                <img src="https://cdn.minticity.com/assets/images/logo-lg.png" class="mintiLogoImg" alt="logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div id="card" class="col-sm-12 card">
        <div id="card-header" class="card-header text-center">
          <div class="row my-2">
            <div class="col-12 text-center">
              <a href="https://www.minticity.com/">
                <img src="https://cdn.minticity.com/assets/images/logo-lg.png" class="mintiLogoImg" alt="logo">
              </a>
            </div>
            <div class="col-12 text-center">
              <h4 class="text-bold mb-0">{{ lang.okul_seciniz }}</h4>
            </div>
          </div>
        </div>
        <div class="card-body row justify-content-center">
          <div class="col-sm-12 col-md-3 cursor-pointer hover:bg-green-minti hover:text-white br1"
            v-for="(val, key) in userschoolstypeaccess" @click="schoolSelect(val)" :key="key + '_peaces'">
            <div class="logo-frame">
              <img class="img-fluid" :src="val.images.medium" :alt="val.name">
              <h5 class="text-center mt-3">{{ val.name }}</h5>
            </div>
          </div>
          <!-- <div class="col-md-4" v-for="(val, key) in userschoolstypeaccess">
            <div class="card card-widget widget-user-2" @click="schoolSelect(val)">
              <div class="widget-user-header bg-default">
                <div class="widget-user-image kutu">
                  <img class="img-fluid" :src="val.images.big" :alt="val.name">
                </div>
                <h5 class="text-center mt-3">{{ val.name }}</h5>
              </div>
            </div>
          </div> -->
      </div>
    </div>
  </div>
</div></template>

<script>
export default {
  props: {
    lang: { type: Object, required: true },
    session: { type: Object, required: false },
  },
  data() {
    return {
      onTeenage: false,
      onJunior: false,
      onKids: false,
      userschoolstypeaccess,
      selected: null,
      redirects,
      isAdmin: false,
    }
  },
  mounted() {
    if (this.userschoolstypeaccess.length === 1) {
      this.selected = this.userschoolstypeaccess[0];
    }
    this.isAdmin = App.user.member_type === 1;
  },
  methods: {
    schoolSelect(school) {
      axios.post('/api/chooseschool', { schoolID: school.id })
        .then((response) => {
          this.selected = school;
        })
        .catch((ex) => {
          console.log(ex)
        });
    },
    typeSelect(type) {
      $('body').addClass('loading');
      if (this.session && this.session[type]) {
        return window.location = this.session[type];
      } else if (this.redirects[type]) {
        return window.location = this.redirects[type];
      }
      return window.location = '/' + type;
    }
  }
};
</script>

<style type="text/css" scoped>
.logo-frame {
  background: url('https://cdn.minticity.com/assets/images/account/logo-frame.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.top-btn {
  top: 1%;
  right: 10%;
}

.hover\:bg-green-minti:hover {
  background-color: #8AC440 !important;
}

.admin {
  margin-top: 1.25rem;
}

@media (max-width: 768px) {
  .admin {
    margin-top: 0;
  }
}

#card {
  margin-top: 6vw;
  border-radius: 2.5rem;
  background: rgba(143, 143, 143, .6);
}

#card-header {
  color: #0A70C4;
  /*background: white;*/
  border-radius: 2.5rem 2.5rem 0 0;
}

.br25 {
  border-radius: 2.5rem;
}

.br1 {
  border-radius: 1rem;
}

h3,
h4 {
  color: #0A70C4;
}

.col-sm-12>img {
  width: 90%;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

.cardItem {
  margin: 10px;
  max-width: 220px;
}

.mintiLogoImg {
  width: 200px;
}
.top-text{
  color: #fff;
  font-weight: bold;
  font-size: 5vh;
  padding-left: 20vh;
}
</style>
